import { RefreshCw } from 'lucide-react';
import { useAuthStore } from '@/store/authStore';
import { useRail1Link } from '@/hooks/useRail1Link';
import { cn } from '@/lib/utils';

export interface Rail1LinkBadgeProps {
  className?: string;
}

/**
 * Persistent retry surface for a failed rail1<->rail2 account link. Renders
 * nothing unless linking has actually failed — a successful/pending/never-
 * attempted link is invisible chrome, not something to surface to the user.
 */
function Rail1LinkBadge({ className }: Rail1LinkBadgeProps) {
  const status = useAuthStore((s) => s.rail1LinkStatus);
  const retry = useRail1Link();

  if (status !== 'failed') return null;

  return (
    <button
      type="button"
      onClick={() => void retry()}
      className={cn(
        'flex w-full items-center gap-1.5 rounded-lg border border-rose2-100 bg-rose2-50 px-2.5 py-1.5',
        'text-xs font-medium text-rose2-600 transition-colors duration-150 hover:bg-rose2-100',
        className,
      )}
    >
      <RefreshCw className="h-3 w-3 shrink-0" aria-hidden="true" />
      <span>Link incomplete · Retry</span>
    </button>
  );
}

export default Rail1LinkBadge;
